import React from 'react';
import { Box, BoxProps, withStyles } from '@material-ui/core';
import { formSpacingFactor } from 'globals/units';

export const FsFormFullWidthContainer = withStyles(
  () => ({})
)((props: BoxProps) => <Box marginBottom={formSpacingFactor * 2} {...props} />);

export default FsFormFullWidthContainer;
